export default __webpack_public_path__ + "static/media/yuka-carrot.df374530.svg";